


































































































































































































































































































































































































































































































































































import { Component, Mixins, Ref, Watch } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import FireStoreMixin, { Collections } from "@/mixins/firestoreMixin";
import {
  PatientInfo,
  DefaultReceiptSearchCondition,
  DefaultPatientInfo
} from "#/model/receipt";
import { ProcessState } from "@/views/reciept/types";
import { PreCheckState } from "@/views/reciept/types";
import InfiniteLoading from "vue-infinite-loading";
import { PreCheckHistory } from "#/model/precheck";
import { DataTableHeader } from "vuetify/types/index";
import PrecheckPatientTable from "@/components/receipt/precheck/PrecheckPatientTable.vue";
import { db } from "#/mixins/firebase";

@Component({
  components: {
    PrecheckPatientTable
  }
})
export default class PreCheck extends Mixins(
  AxiosMixin,
  UtilMixin,
  FireStoreMixin,
  InfiniteLoading
) {
  /** firestoreに保存する条件 */
  public condition = DefaultReceiptSearchCondition();

  /** 無限ローディング */
  @Ref("infiniteLoading")
  private readonly infiniteLoading!: InfiniteLoading;

  /** 読み込みページ数 */
  private page = 1;

  /** 一回で取得するデータ量 */
  private limit = 10;

  private histories: PreCheckHistory[] = []; //未読一覧

  private historyRecords: { [key: number]: PreCheckHistory } = {};

  private patients: PatientInfo[] = [];

  private yearMonthDialogMessage = "処理対象年月が取得できませんでした。";

  private confirmDialogMessage = "";

  /** テーブルのヘッダー */
  private header: DataTableHeader[] = [
    {
      text: "状態",
      value: "status_flag",
      align: "center",
      width: "120px",
      cellClass: "text-center"
    },
    {
      text: "処理対象年月",
      value: "yearmonth",
      align: "center",
      width: "",
      cellClass: "text-center"
    },
    {
      text: "処理日時",
      value: "date_processed",
      align: "center",
      width: "",
      cellClass: "text-center"
    },
    {
      text: "処理人数",
      value: "processed_count",
      align: "center",
      width: "",
      cellClass: "text-center"
    },
    {
      text: "対象人数",
      value: "total_count",
      align: "center",
      width: "",
      cellClass: "text-center"
    },
    {
      text: "処理結果",
      value: "action",
      align: "center",
      width: "",
      cellClass: "text-center"
    }
  ];

  /** 実行回数カウント（新しくタブを開いてからの実行回数） */
  private ownCheckDone = false;

  /** 処理合計 */
  private total = 0;

  /** 処理カウント */
  private count = 0;

  /** 処理状態 */
  private processState = 1;

  /** タブ情報 */
  private tab = 0;

  /** 処理が完了したタブ情報 */
  private processCompletedTabs: number[] = [];

  /** 処理再開フラグ */
  private isRestart = false;

  /** 再開対象が処理前確認（プレビュー）だったかどうか */
  private isPreviewRestart = false;

  /** プレビュー結果の二重ダウンロード防止用（最後にダウンロードしたExcelパス） */
  private lastDownloadedUrl = "";

  private hint =
    "下記3点を満たすと処理の対象になります。\n1．レセプト処理画面で選択している利用者\n2．同一建物を設定した訪問看護記録書Ⅰが提出済み\n※訪問看護記録書Ⅰ＞お住まいの状況に関する項目＞住居環境＞施設説明に連携機関マスタに登録している同一建物を設定している\n3．登録または確定されている実績（精神科訪問看護を含む）\n※請求履歴確定は含まない";

  /** 選択された利用者一覧 */
  private selectPatients: PatientInfo[] = [];

  /** レセプト事前チェックのID */
  private preCheckId = -1;

  /** 表示用の変数 */
  private targetYearmonth = "";
  private innerTotalCount = 0;
  private innerCount = 0;
  private innerState = 1;
  private isOwnCheck = false;
  private isStaffIdOK = true;

  private isConfrimFukusuQualif = false;
  private isConfrimSameBuilding = false;
  private isConfirmComprehensive = false;
  private isConfirmPreview = false;
  private isConfirmStartReminder = false;

  // ダイアログ
  private isOpenDialog = false;
  private isOpenYearmonthDialog = false;
  private isOpenConfirmDialog = false;
  private isOpenConfirmFukusuQualifDialog = false;
  private isOpenConfirmSameBuildinghDialog = false;
  private isOpenConfirmComprehensiveDialog = false;
  private isOpenAdjustBuildingDialog = false;
  private isOpenConfirmPreviewDialog = false;
  private isOpenConfirmStartReminderDialog = false;

  /** 単一建物調整人数（確定値） */
  private singleBuildingAdjustCount = 0;

  /** 対象事業所設定の包括型訪問看護療養費フラグ */
  private medicalComprehensiveFlg = 0;
  /** 単一建物調整人数（ダイアログ内編集用の一時値） */
  private singleBuildingAdjustCountInput: number | string = 0;

  private isPreview = false;

  /** 利用者 */
  private isUpdatingPatientList = false;

  /** レセプト事前チェック 検証ボタン配置用フラグ（暫定措置） */
  private showPreCheckTestButton = false;

  /** タブ定数 */
  PATIENT_SELECT = 0;

  /** 管理（包括）療養費タブが表示されるか（2026年6月以降） */
  private get isComprehensiveVisible(): boolean {
    if (!this.targetYearmonth) return false;
    const [year, month] = this.targetYearmonth.split("-").map(Number);
    return year > 2026 || (year === 2026 && month >= 6);
  }

  /** 確認ダイアログ・処理対象の利用者一覧（包括型タブでは全利用者、それ以外はselectPatients） */
  private get confirmTargetPatients(): PatientInfo[] {
    if (this.tab === this.COMPREHENSIVE_VISIT) {
      return this.patients;
    }
    return this.selectPatients;
  }

  /** 包括型タブのインデックス（v-showで常にDOMに存在するため固定値） */
  private get COMPREHENSIVE_VISIT(): number {
    return 1;
  }

  /** 複数名加算タブのインデックス */
  private get FUKUSU_QUALIF(): number {
    return 2;
  }

  /** 同一建物減算タブのインデックス */
  private get SAME_BUILDING(): number {
    return 3;
  }

  @Watch("selectPatients", { deep: true }) watchSelectPatients() {
    this.total = this.getPreCheckPatient(this.confirmTargetPatients);
  }

  @Watch("tab") watchTab() {
    this.total = this.getPreCheckPatient(this.confirmTargetPatients);
    this.changeHint();
    if (this.tab !== 0) {
      // タブ変更時に履歴更新を実施
      this.page = 0;
      this.resetProcessState(); // 処理状況をリセット
      this.historyRecords = {}; // 重複を防ぐためリセット
      this.getPreCheckHistory();
      this.openConfirmDialog();
    }
  }

  /** 処理状況をリセット */
  private resetProcessState() {
    // 前のタブで処理が行われていたとき
    if (this.count) {
      this.processState = ProcessState.UNPROCESS;
      this.count = 0;
    }
  }

  /** リアルタイムアップデート用リスナーをデタッチする関数 */
  private detach = () => {
    return;
  };

  private statusText(item: PreCheckHistory): string {
    switch (item.status_flag) {
      case 0:
        return "処理中";
      case 1:
        if (this.isFiveMinutesPassed(item.date_processed)) {
          return "エラー";
        } else {
          return "処理中";
        }
      case 2:
        return "完了";
      case 3:
        return "中断";
      default:
        return "エラー";
    }
  }

  async created() {
    // 前画面でセットされた利用者と検索条件を取得
    const lsPatients = localStorage.getItem("PreCheckSelectPatients");
    const lsCondition = localStorage.getItem("PreCheckCondition");

    if (lsPatients !== null) {
      this.selectPatients = JSON.parse(lsPatients);
    }

    if (lsCondition !== null) {
      this.condition = JSON.parse(lsCondition);
      this.targetYearmonth = this.condition.search_cond.yearmonth;
    }

    localStorage.removeItem("PreCheckSelectPatients");
    localStorage.removeItem("PreCheckCondition");

    // 遷移してきたときの初期値
    this.total = this.innerTotalCount;
    this.count = 0;

    // 事業者IDが取得できない場合は何もしない
    if (this.condition.search_cond.office_id === 0) {
      await this.openDialog();
      return;
    }

    // 処理対象年月が取得できない場合も何もしない
    if (this.targetYearmonth === "") {
      await this.openYearmonthDialog();
      return;
    }

    // 建物人数調整値
    this.fetchPreCheckOfficeSettings();

    // 利用者一覧を取得
    this.patientSearch();
  }
  mounted() {
    // リアルタイムアップデート用リスナーを作成
    this.createListener();
  }

  beforeDestroy() {
    // リアルタイムアップデート用リスナーをデタッチ
    this.detach();
  }
  /** リアルタイムアップデート用リスナーの作成 */
  private createListener() {
    const docId = this.createDocumentId(this.condition.search_cond.office_id);
    this.detach = db
      .collection(Collections.ReceiptPreCheck)
      .where("id", "==", docId)
      .onSnapshot(ss => {
        ss.docChanges().forEach(docChange => {
          const stateData = docChange.doc.data() as PreCheckState;
          stateData.id = docChange.doc.id;

          // 5分以上前の書き込みなら無いものとして扱う（安全装置）
          const isFiveMinutesPassed = this.isFiveMinutesPassed(stateData.time);
          if (isFiveMinutesPassed) {
            return;
          }

          // 自分が実行しているかどうか(再開できるかどうか)
          this.isOwnCheck = stateData.pre_check_id == this.preCheckId;

          // この処理者が中断できるチェックかどうか
          this.isStaffIdOK = stateData.staff_id == this.loginUser.staff_id;

          if (stateData.url != "") {
            this.page = 0;
            this.getPreCheckHistory();
          }

          if (this.processState == ProcessState.DISABLED) {
            return;
          }

          switch (stateData.status_flag) {
            case 1: //処理中
              this.preCheckId = this.ownCheckDone ? stateData.pre_check_id : 0;
              this.processState = ProcessState.PROCESSING;
              this.count = stateData.number_processe;
              this.total = stateData.total_count;
              break;
            case 2: //処理完了
              if (stateData.is_preview === true) {
                // Firestore書き込みが再送等で同一urlのまま複数回変更検知されても
                // 二重ダウンロードにならないようにする
                if (stateData.url && stateData.url !== this.lastDownloadedUrl) {
                  this.lastDownloadedUrl = stateData.url;
                  let pre_check_div = 1;
                  if (this.tab == this.SAME_BUILDING) {
                    pre_check_div = 2;
                  } else if (this.tab == this.COMPREHENSIVE_VISIT) {
                    pre_check_div = 3;
                  }

                  this.postJsonCheck(
                    window.base_url + "/api/receipt/downloadPreCheckResultAll",
                    {
                      path: stateData.url,
                      id: stateData.pre_check_id,
                      office_id: this.condition.search_cond.office_id,
                      pre_check_div: pre_check_div,
                      is_preview: true
                    },
                    res => {
                      location.href = res.data.path;
                    }
                  );
                  // 進捗状況をクリアして初期状態に戻す
                  this.processState = ProcessState.UNPROCESS;
                  this.count = 0;
                  this.ownCheckDone = false;
                  this.isPreview = false;
                  this.isRestart = false;
                  this.isPreviewRestart = false;
                }
              } else {
                this.processState = this.isOwnCheck
                  ? ProcessState.DISABLED
                  : this.innerState;

                if (!this.isOwnCheck) {
                  this.backState();
                } else {
                  // 自分の処理が完了したので中断・再開状態をクリアする
                  this.isRestart = false;
                  this.isPreviewRestart = false;
                }
              }
              this.page = 0;
              this.getPreCheckHistory();
              break;
            case 3: //処理中断
              this.processState = this.isOwnCheck
                ? ProcessState.INTERRUPTED
                : this.innerState;

              if (!this.isOwnCheck) {
                this.backState();
              } else {
                this.ownCheckDone = false;
                this.isRestart = true;
                this.isPreviewRestart = stateData.is_preview === true;
              }

              this.page = 0;
              this.getPreCheckHistory();
              break;
            case 4: //処理再開
              break;
            case 5:
              this.saveState();
              break;
            default:
            //
          }
        });
      });
  }

  // 5分以上前か比較
  private isFiveMinutesPassed(timeString: string) {
    const targetDate = new Date(timeString);
    const now = new Date();
    const diff = now.getTime() - targetDate.getTime();
    const fiveMinutesInMilliseconds = 300000;

    return Math.abs(diff) > fiveMinutesInMilliseconds;
  }

  private backState() {
    this.innerState = this.processState;
    this.total = this.innerTotalCount;
    this.count = this.innerCount;
  }

  private saveState() {
    this.innerState = this.processState;
    this.innerTotalCount = this.total;
    this.innerCount = this.count;
  }

  private createDocumentId(officeId: number) {
    return String(officeId);
  }

  private get getNextButtonMessage(): string {
    if (this.tab === this.PATIENT_SELECT) {
      if (this.isComprehensiveVisible) {
        return "2.管理（包括）療養費の画面へ進む";
      }
      return "2.複数名加算の画面へ進む";
    } else if (this.tab === this.COMPREHENSIVE_VISIT) {
      const nextNum = this.isComprehensiveVisible ? "3" : "2";
      return this.processCompletedTabs.includes(this.COMPREHENSIVE_VISIT)
        ? `${nextNum}.複数名加算の画面へ進む`
        : "スキップ";
    } else if (this.tab === this.FUKUSU_QUALIF) {
      const nextNum = this.isComprehensiveVisible ? "4" : "3";
      return this.processCompletedTabs.includes(this.FUKUSU_QUALIF)
        ? `${nextNum}.同一建物減算の画面へ進む`
        : "スキップ";
    } else if (this.tab === this.SAME_BUILDING) {
      return this.processCompletedTabs.includes(this.SAME_BUILDING)
        ? "画面を閉じる"
        : "スキップして画面を閉じる";
    } else {
      return "";
    }
  }

  /** レセプト事前チェックの履歴を取得 */
  private getPreCheckHistory() {
    let pre_check_div = 1;
    if (this.tab == this.SAME_BUILDING) {
      pre_check_div = 2;
    } else if (this.tab == this.COMPREHENSIVE_VISIT) {
      pre_check_div = 3;
    }

    this.postJsonCheck(
      window.base_url + "/api/receipt/preCheck/history",
      {
        page: this.page,
        office_id: this.condition.search_cond.office_id,
        pre_check_div: pre_check_div
      },
      res => {
        if (res.data.histories != null) {
          // 重複を除外している
          res.data.histories.forEach((history: PreCheckHistory) => {
            this.historyRecords[history.id] = history;
          });
          this.histories = Object.values(this.historyRecords);
          this.histories.sort((a, b) => b.id - a.id);

          if (res.data.histories.length < 10) {
            //これ以上読み込まない
            this.infiniteLoading.stateChanger.complete();
          }
          // まだ読み込む
          this.page += 1;
          this.infiniteLoading.stateChanger.loaded();
        } else {
          if (this.page <= 1) {
            this.historyRecords = {};
            this.histories = [];
          }
          this.infiniteLoading.stateChanger.complete();
        }
      }
    );
  }

  /** 利用者一覧の取得 */
  private patientSearch() {
    this.isUpdatingPatientList = true;
    this.patients = [];
    //請求
    this.postJsonCheck(
      window.base_url + "/api/receipt/patients/search",
      {
        yearmonth: this.condition.search_cond.yearmonth,
        office_id: this.condition.search_cond.office_id,
        tab: 0 // 医療・介護含めて取得
      },
      res => {
        this.patients = res.data.patients;
        this.showPreCheckTestButton =
          res.data.show_pre_check_test_button === true;
        this.isUpdatingPatientList = false;
      },
      () => {
        this.isUpdatingPatientList = false;
      }
    );
  }

  /** 次のタブへ進むボタン */
  private nextProcess() {
    if (this.tab != this.SAME_BUILDING) {
      this.tab++;
      // 管理（包括）療養費タブが非表示の場合はスキップ
      if (
        this.tab === this.COMPREHENSIVE_VISIT &&
        !this.isComprehensiveVisible
      ) {
        this.tab++;
      }
    } else {
      // 同一建物タブの場合、ウィンドウを閉じる
      this.closeWindow();
    }
  }

  /** 「処理開始」ボタン無効化 */
  private get StartButtonDisabled(): boolean {
    return (
      !this.total ||
      [
        ProcessState.PROCESSING,
        ProcessState.DISABLED,
        ProcessState.PROCESSED
      ].includes(this.processState)
    );
  }

  /** 「処理中断」ボタン無効化 */
  private get InterruptButtonDisabled(): boolean {
    return (
      [
        ProcessState.UNPROCESS,
        ProcessState.PROCESSED,
        ProcessState.INTERRUPTING,
        ProcessState.INTERRUPTED,
        ProcessState.DISABLED
      ].includes(this.processState) || this.ownPreCheckProcessing() //処理中の時も一定条件で中断ボタン無効化
    );
  }

  // 処理中だが自分の処理でない
  private ownPreCheckProcessing(): boolean {
    return this.processState == ProcessState.PROCESSING && !this.isStaffIdOK;
  }

  /** 処理を中断する */
  private interruption() {
    const stopPath = "/api/receipt/aggregateSameBuildingAll/stop";

    this.postJsonCheck(
      window.base_url + stopPath,
      {
        yearmonth: this.condition.search_cond.yearmonth,
        office_id: this.condition.search_cond.office_id
      },
      () => {
        this.page = 0;
        this.getPreCheckHistory();
      }
    );
  }

  /** ダウンロードする */
  private downloadAll(item: any) {
    let pre_check_div = 1;
    if (this.tab == this.SAME_BUILDING) {
      pre_check_div = 2;
    } else if (this.tab == this.COMPREHENSIVE_VISIT) {
      pre_check_div = 3;
    }

    this.postJsonCheck(
      window.base_url + "/api/receipt/downloadPreCheckResultAll",
      {
        path: item.excel_path,
        id: item.id,
        office_id: this.condition.search_cond.office_id,
        pre_check_div: pre_check_div
      },
      res => {
        location.href = res.data.path;
      },
      async (error, msg) => {
        let alertMsg = "レセプト事前チェック結果ダウンロードに失敗しました";
        if (!!error.isAxiosError && !error.response) {
          alertMsg =
            "インターネットに接続されていない可能性があります。インターネットに接続して再度お試しください。";
        }
        if (error.response && error.response.status == 429) {
          alertMsg =
            "サーバーが大変混み合っています。申し訳ありませんが、しばらくたってからやり直してください。";
        }

        // DBエラー
        if (error.response && error.response.data.code == 200) {
          alertMsg = "レセプト事前チェック結果ダウンロードに失敗しました";
        }
        // 業務エラー
        if (error.response && error.response.data.code == 101) {
          alertMsg = msg != "" ? msg : alertMsg;
        }

        await this.$openAlert(alertMsg);
        return;
      }
    );
  }

  /** 「処理中」に設定 */
  public setProcessing() {
    this.processState = ProcessState.PROCESSING;
  }

  /** 「処理完了」に設定 */
  public setProcessed() {
    this.processState = ProcessState.PROCESSED;
  }

  /** 「中断完了」に設定 */
  public setInterrupted() {
    this.processState = ProcessState.INTERRUPTED;
  }

  /** 処理前確認ボタン押下 */
  private async startPreview() {
    if (!(await this.openConfirmPreviewDialog())) {
      return;
    }
    this.isPreview = true;
    this.startProcess();
  }

  /** 処理開始ボタン押下 */
  private async confirmAndStartProcess() {
    // 中断していた処理前確認（プレビュー）の再開時は案内ダイアログを出さずそのままプレビューとして再開する
    if (this.isRestart && this.isPreviewRestart) {
      this.isPreview = true;
      this.startProcess();
      return;
    }
    if (!(await this.openConfirmStartReminderDialog())) {
      return;
    }
    this.startProcess();
  }

  /** 処理開始 */
  private async startProcess() {
    // 処理開始確認ダイアログの表示 (プレビュー時はスキップ)
    if (!this.isPreview) {
      if (
        this.tab == this.COMPREHENSIVE_VISIT &&
        !(await this.openConfirmComprehensiveDialog())
      ) {
        this.isPreview = false;
        return;
      } else if (
        this.tab == this.FUKUSU_QUALIF &&
        !(await this.openConfirmFukusuQualifDialog())
      ) {
        this.isPreview = false;
        return;
      } else if (
        this.tab == this.SAME_BUILDING &&
        !(await this.openConfirmSameBuildinghDialog())
      ) {
        this.isPreview = false;
        return;
      }
    }

    // 請求履歴未確定の利用者のみ取得
    const patients: PatientInfo[] = this.confirmTargetPatients.filter(
      (sp: PatientInfo) =>
        !sp.invoice_history &&
        sp.medical &&
        ((this.tab == this.COMPREHENSIVE_VISIT && sp.medical) ||
          (this.tab == this.FUKUSU_QUALIF && sp.is_process_fukusu_qualif) ||
          (this.tab == this.SAME_BUILDING && sp.is_process_same_building))
    );

    // 「処理中」に変更
    this.setProcessing();

    // 対象年月が指定されない場合は何もしない(リロードなど)
    if (this.condition.search_cond.yearmonth === null) {
      this.isPreview = false;
      await this.$openAlert("事前チェック対象年月を前画面で選択してください。");
      return;
    }

    this.ownCheckDone = true;
    // 中断後自分のチェック以外が走ったら処理しない
    if (!this.isOwnCheck && this.isRestart) {
      this.isPreview = false;
      await this.$openAlert("別の処理が開始されたため、処理再開できません。");
      this.processState = ProcessState.DISABLED;
      return;
    }

    let processPath = "/api/receipt/aggregateSameBuildingAll";
    if (this.tab == this.FUKUSU_QUALIF) {
      processPath = "/api/receipt/aggregateFukusuQualifAll";
    } else if (this.tab == this.COMPREHENSIVE_VISIT) {
      processPath = "/api/receipt/aggregateComprehensiveVisitAll";
    }

    this.postJsonBackgroundIgnore(
      window.base_url + processPath,
      {
        yearmonth: this.condition.search_cond.yearmonth,
        office_id: this.condition.search_cond.office_id,
        patients: patients,
        restart: this.isRestart,
        id: this.preCheckId,
        single_building_adjust_count: this.singleBuildingAdjustCount,
        is_preview: this.isPreview
      },
      () => {
        if (patients.length == 0) {
          // 処理対象利用者なしで処理開始APIを実行した場合はここでステータスを完了に変える
          this.processState = ProcessState.PROCESSED;
        }
        if (!this.processCompletedTabs.includes(this.tab)) {
          this.processCompletedTabs.push(this.tab);
        }
      },
      async (error, msg) => {
        this.isPreview = false;
        let alertMsg = "レセプト事前チェック実行に失敗しました";
        if (!!error.isAxiosError && !error.response) {
          alertMsg =
            "インターネットに接続されていない可能性があります。インターネットに接続して再度お試しください。";
        }
        if (error.response && error.response.status == 429) {
          alertMsg =
            "サーバーが大変混み合っています。申し訳ありませんが、しばらくたってからやり直してください。";
        }

        // DBエラー
        if (error.response && error.response.data.code == 200) {
          alertMsg = "レセプト事前チェック実行に失敗しました";
        }
        // 業務エラー
        if (error.response && error.response.data.code == 101) {
          alertMsg = msg != "" ? msg : alertMsg;
        }

        await this.$openAlert(alertMsg);
        this.processState = ProcessState.DISABLED;
        return;
      }
    );
  }

  /** Excelダウンロードパスが正しいかどうか*/
  private isInvalidLink(path: string) {
    const regex = /^\d+\/excel\/\d{4}-\d{2}\/.*\.xlsx$/;
    return !regex.test(path);
  }

  private closeWindow() {
    window.close();
  }

  private get BgColor() {
    return "rgb(251,245,229) !important"; // 常に指定した色にする
  }

  private get Color() {
    return "warning"; // 常にwarning色にする
  }

  private getColorByStatus(item: PreCheckHistory) {
    switch (item.status_flag) {
      case 0:
        return "success-outlined";
      case 1:
        if (this.isFiveMinutesPassed(item.date_processed)) {
          return "error";
        } else {
          return "success-outlined";
        }
      case 2:
        return "success";
      case 3:
        return "error";
      default:
        return "error";
    }
  }

  private async openDialog() {
    this.isOpenDialog = true;

    return new Promise<void>(resolve => {
      const interval = setInterval(() => {
        if (!this.isOpenDialog) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    });
  }

  private async openYearmonthDialog() {
    this.isOpenYearmonthDialog = true;

    return new Promise<void>(resolve => {
      const interval = setInterval(() => {
        if (!this.isOpenYearmonthDialog) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    });
  }

  /** タブ切り替え時 確認ダイアログ表示 */
  private async openConfirmDialog() {
    if (this.tab == this.COMPREHENSIVE_VISIT) {
      this.confirmDialogMessage =
        "医療保険の管理療養費について自動で正しく算定できます。また、包括型訪問看護療養費についても、自動で正しく算定できます。利用者の対象は事業所内の全利用者です。よろしいですか？";
    } else if (this.tab == this.FUKUSU_QUALIF) {
      this.confirmDialogMessage =
        "医療保険の複数名加算の登録内容を確認し、自動で最適な算定に変更できます。利用者の選択状況は下記のとおりです。よろしいですか？";
    } else {
      this.confirmDialogMessage =
        "医療保険の同一建物居住者への訪問に該当するかを確認し、自動で正しく算定できます。利用者の選択状況は下記のとおりです。よろしいですか？";
    }

    this.isOpenConfirmDialog = true;

    return new Promise<void>(resolve => {
      const interval = setInterval(() => {
        if (!this.isOpenConfirmDialog) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    });
  }

  /** 建物人数調整入力のバリデーション */
  private get adjustCountRules(): (string | boolean)[] {
    const v = this.singleBuildingAdjustCountInput;
    const num = Number(v);
    if (
      v === "" ||
      v === null ||
      isNaN(num) ||
      !Number.isInteger(num) ||
      num < 0
    ) {
      return ["0以上の整数を入力してください"];
    }
    return [true];
  }

  /** 建物人数調整ダイアログを開く */
  private openAdjustBuildingDialog() {
    this.singleBuildingAdjustCountInput = this.singleBuildingAdjustCount;
    this.isOpenAdjustBuildingDialog = true;
  }

  /**
   * 建物人数調整値（事業所×年月）をDBから取得し、入力欄のデフォルト値に設定
   */
  private fetchPreCheckOfficeSettings() {
    this.postJsonCheck(
      window.base_url + "/api/receipt/preCheck/officeSettings/get",
      {
        yearmonth: parseInt(
          this.condition.search_cond.yearmonth.replace("-", "")
        ),
        office_id: this.condition.search_cond.office_id
      },
      res => {
        const data = res.data.data;
        this.singleBuildingAdjustCount =
          (data && data.adjust_single_building_count) || 0;
        this.medicalComprehensiveFlg = res.data.medical_comprehensive_flg ?? 0;
      }
    );
  }

  /** 建物人数調整の保存 */
  private saveAdjustBuildingCount() {
    const num = Number(this.singleBuildingAdjustCountInput);
    const adjustCount = isNaN(num) || num < 0 ? 0 : Math.floor(num);

    this.postJsonCheck(
      window.base_url + "/api/receipt/preCheck/officeSettings/save",
      {
        yearmonth: parseInt(
          this.condition.search_cond.yearmonth.replace("-", "")
        ),
        office_id: this.condition.search_cond.office_id,
        adjust_single_building_count: adjustCount
      },
      () => {
        this.singleBuildingAdjustCount = adjustCount;
        this.isOpenAdjustBuildingDialog = false;
      }
    );
  }

  /** 建物人数調整のキャンセル */
  private cancelAdjustBuildingCount() {
    this.singleBuildingAdjustCountInput = this.singleBuildingAdjustCount;
    this.isOpenAdjustBuildingDialog = false;
  }

  /** 処理前確認 開始確認ダイアログ表示 */
  private async openConfirmPreviewDialog() {
    this.isOpenConfirmPreviewDialog = true;

    return new Promise<boolean>(resolve => {
      const interval = setInterval(() => {
        if (!this.isOpenConfirmPreviewDialog) {
          clearInterval(interval);
          resolve(this.isConfirmPreview);
        }
      }, 100);
    });
  }

  /** 処理開始 事前案内ダイアログ表示 */
  private async openConfirmStartReminderDialog() {
    this.isOpenConfirmStartReminderDialog = true;

    return new Promise<boolean>(resolve => {
      const interval = setInterval(() => {
        if (!this.isOpenConfirmStartReminderDialog) {
          clearInterval(interval);
          resolve(this.isConfirmStartReminder);
        }
      }, 100);
    });
  }

  /** 包括型訪問看護療養費 処理確認ダイアログ表示 */
  private async openConfirmComprehensiveDialog() {
    this.isOpenConfirmComprehensiveDialog = true;

    return new Promise<boolean>(resolve => {
      const interval = setInterval(() => {
        if (!this.isOpenConfirmComprehensiveDialog) {
          clearInterval(interval);
          resolve(this.isConfirmComprehensive);
        }
      }, 100);
    });
  }

  /** 複数名加算 処理確認ダイアログ表示 */
  private async openConfirmFukusuQualifDialog() {
    this.isOpenConfirmFukusuQualifDialog = true;

    return new Promise<boolean>(resolve => {
      const interval = setInterval(() => {
        if (!this.isOpenConfirmFukusuQualifDialog) {
          clearInterval(interval);
          resolve(this.isConfrimFukusuQualif);
        }
      }, 100);
    });
  }

  /** 同一建物減算 処理確認ダイアログ表示 */
  private async openConfirmSameBuildinghDialog() {
    this.isOpenConfirmSameBuildinghDialog = true;

    return new Promise<boolean>(resolve => {
      const interval = setInterval(() => {
        if (!this.isOpenConfirmSameBuildinghDialog) {
          clearInterval(interval);
          resolve(this.isConfrimSameBuilding);
        }
      }, 100);
    });
  }

  /** ヒントに表示する内容を変更 */
  private changeHint() {
    if (this.tab == this.COMPREHENSIVE_VISIT) {
      this.hint =
        "登録または確定されている（※請求履歴確定は含まない）場合、療養費算定処理の対象になります。\nさらに、下記2点を満たすと包括型訪問看護管理療養費の対象になります。\n1．マスタメンテ > 事業所マスタ > 包括型訪問看護療養費 を「あり」にしている\n2．同一建物を設定した訪問看護記録書Ⅰが提出済み\n　※訪問看護記録書I > お住まいの状況に関する項目 > 住居環境 > 施設説明に連携機関マスタに登録している同一建物・同一建物グループを設定している。";
    } else if (this.tab == this.SAME_BUILDING) {
      this.hint =
        "下記3点を満たすと処理の対象になります。\n1．「利用者選択」で選択している利用者\n2．同一建物を設定した訪問看護記録書Ⅰが提出済み\n　※訪問看護記録書Ⅰ＞お住まいの状況に関する項目＞住居環境＞施設説明に連携機関マスタに登録している同一建物を設定している\n3．登録または確定されている実績（精神科訪問看護を含む）\n　※請求履歴確定は含まない";
    } else {
      this.hint =
        "下記3点を満たすと処理の対象になります。\n1．「利用者選択」で選択している利用者\n2．同行者を設定した訪問看護記録書Ⅱが提出済み\n3．登録または確定されている実績（精神科訪問看護を含む）\n　※請求履歴確定は含まない";
    }
  }

  //------------------------------------------
  // 選択された利用者一覧が変更
  //------------------------------------------
  private ChangeSelectPatients(selectPatients: PatientInfo[]) {
    this.selectPatients = selectPatients;
  }

  //------------------------------------------
  // 検索ボックスに入力されている値が変更
  //------------------------------------------
  private ChangePatientName(patientName: string) {
    this.condition.search_cond.patient_name = patientName;
  }

  //------------------------------------------
  // 指定された処理の対象となっている利用者一覧を取得
  //------------------------------------------
  private getSelectPatientsByProcessTarget(type: number) {
    return this.selectPatients.filter(
      (p: PatientInfo) =>
        (type === this.COMPREHENSIVE_VISIT && p.medical) ||
        (type === this.FUKUSU_QUALIF && p.is_process_fukusu_qualif) ||
        (type === this.SAME_BUILDING && p.is_process_same_building)
    );
  }

  /** レセプト事前チェック処理対象数取得 */
  private getPreCheckPatient(patients: PatientInfo[]): number {
    // 医療実績と請求未確定のみが対象
    return patients.filter(
      patient =>
        patient?.medical != "" &&
        patient?.invoice_history == "" &&
        (this.tab == this.COMPREHENSIVE_VISIT
          ? true // 包括型は医療実績がある利用者全員が対象
          : this.tab == this.FUKUSU_QUALIF
          ? patient?.is_process_fukusu_qualif
          : patient?.is_process_same_building)
    ).length;
  }
}
